<template>
  <div class="door-config__group-wrapper" ref="wrapper_modal">

    <div
      v-for="(filter, index) in jsonData"
      :key="index"
      :class="[classWrapperWidth, index, classHiddenHandle(index)]"
      :id="'modal_' + index"
    >
      <a
        @click="$emit('closeModal')"
        v-show="showModalMobile(index) && mobile"
        data-fancybox-close
        href="#"
        class="door-config-modal__back"
        >
        <i><svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg></i>
      </a>
      <a
        v-if="showModalMobilePreview(index)"
        class="door-config__img-container js--door-config-img-container js--popup"
      >
        <div class="door-config__img-item _pokr">
          <img :src="selected?.picture" class="js--door-config-img js--door-config-polotno _loaded"/>
        </div>
      </a>
      <div
        :class="[classWrapperWidthChild, index]"
        v-show="showModalMobile(index)"
      >
        <div
          class="door-config__group"
          :style="showModalMobile(index)"
          :data-name="index"
        >

          <div class="h3 color-green"
               :class="{ info__size: index == 'size' }"
          >

            {{ readTitleGroup(index) }}

            <div v-show="index == 'size'" class="door-config__cover info__size">
              <div class="door-config__info info__size"><a class="hint js--popup js--door-config-measuring-btn">i</a></div>
              <span>Изображение соответствует размерам полотен 900х2500 мм</span>
            </div>

          </div>

          <div class="tabs" :class="{ flex: index == 'handle' }">

            <div class="door-config__tab-menu"
                 v-if="index == 'glass' || index == 'cover'"
            >
              <TheTabMenu
                :activeTabIndex="activeTabIndexGroup[index]"
                :filter="filter"
                :index="index"
                @clickTab="clickTab"
              />
            </div>

            <div v-if="index == 'handle'"
                 v-show="parentFormData?.handle?.handleName"
            >
              <TheTabImage
                :activeTabIndex="activeTabIndexGroup[index]"
                :filter="filter"
                :index="index"
                @clickTab="clickTab"
              />
              <div class="js--door-config-polotno-text f-s-12 mt-0_5-rem">
                {{ readResultHandle(index) }}
              </div>
            </div>

            <TheTabsItem
              v-if="index == 'glass' || index == 'cover'"
              @change="changeCoverGlass"
              :selectedParent="selectedNotCategory(parentFormData[index])"
              :activeTabIndexParent="activeTabIndexGroup"
              :indexParent="index"
              :filter="filter"
            />

            <div :class="index"
                 v-if="index == 'mechanism'"
            >
              <TheTabsItem
                @change="changeMechanism"
                :selectedParent="selectedMechanism"
                :selectedCountCover="selectedCountCover"
                :indexParent="index"
                :filter="filter"
              />
            </div>

            <div :class="index"
                 v-if="index == 'countcover'"
            >
              <TheTabsItem
                @change="changeCountCover"
                :selectedParent="parentFormData[index]"
                :selectedCountCover="parentFormData[index]"
                :indexParent="index"
                :filter="filter"
                :width="sizeWidth"
              />
            </div>

            <div :class="index"
                 v-if="index == 'handle'"
                 v-show="parentFormData?.handle?.handleName"
            >
              <span
                class="h5 color-text-light"
                style="grid-row: 1; display: block; grid-column: 1"
                >Цвет</span
              >
              <TheTabsItem
                @change="changeCoverGlass"
                :selectedMechanism="selectedMechanism"
                :selectedParent="parentFormData.handle"
                :activeTabIndexParent="activeTabIndexGroup"
                :indexParent="index"
                :filter="filter"
              />
            </div>

            <div :class="index"
                 v-if="index === 'kreplenie_for_alumini'"
            >

              <div class="row">
                <div v-for="item in filter"
                     class="form-item _min-margin"
                     style="margin-left: 20px; margin-right: 10px;"
                >
                  <label class="form-item__radio type">
                    <input type="radio"
                           v-model="kreplenie_for_alumini"
                           :value="item.value"
                    >
                    <i></i>
                    {{ item.text }}
                  </label>
                </div>
              </div>

            </div>

          </div>

          <div class="js--inputs"
               v-if="index == 'size'"
          >
            <div class="form-item"
                 style="margin: 0"
                 :class="{ '_not-empty': sizeWidth }"
            >
              <input
                type="tel"
                name="name"
                v-model.number="sizeWidth"
                :min="selectedCountCover?.min"
                :max="selectedCountCover?.max"
                @blur="readInputWidthValue"
                @keyup.enter="readInputWidthValue"
              />
              <label class="form-item__label">Ширина, мм</label>
            </div>
            <div
              class="form-item"
              style="margin: 0"
              :class="{ '_not-empty': sizeHeight }"
            >
              <input
                type="tel"
                name="name"
                :min="filter?.height?.min"
                :max="filter?.height?.max"
                v-model.number="sizeHeight"
                @blur="readInputHeightValue"
                @keyup.enter="readInputHeightValue"
              />
              <label class="form-item__label">Высота, мм</label>
            </div>
          </div>

          <div
            class="js--door-config-polotno-text f-s-12 mt-0_5-rem"
            v-show="index != 'size' && index != 'handle'"
          >
            {{ readResult(index) }}
          </div>

        </div>

      </div>
      <button
        @click="$emit('closeModal')"
        data-fancybox-close
        v-show="showModalMobile(index) && mobile"
        type="button"
        class="btn door-config-modal__btn"
      >
        Готово
      </button>
    </div>

  </div>
</template>

<script>
import TheTabsItem from "./TheTabsItem.vue";
import TheTabMenu from "./TheTabMenu.vue";
import TheTabImage from "./TheTabImage.vue";
export default {
  name: "TheGroup",
  data() {
    return {
      activeTabIndexGroup: {
        cover: 0,
        glass: 0,
        handle: 0,
      },
      sizeWidth: 1800,
      sizeHeight: 2300,
      parentFormData: {},
      selectedCountCover: {},
      selectedGlass: {},
      selectedCover: {},
      selectedMechanism: {},
      selectedHandle: {},
      kreplenie_for_alumini: null
    };
  },
  computed: {
    classWrapperWidth() {
      return this.mobile ? "hidden door-config-modal" : "";
    },
    classWrapperWidthChild() {
      return this.mobile ? "door-config-modal__wrapper" : "";
    },
  },
  watch: {
    jsonData(value) {
      if (value) {
        this.defaultSelect();
      }
    },
    "selectedCountCover.countcover"(value) {
      if (this.json.mechanism) {
        let [index, obj] = Object.entries(this.json.mechanism[value])[0];
        this.changeMechanism(obj, index);
      }
    },
    sizeWidth(value) {
      let objects = Object.keys(this.json.countcover);
      const lastItemInObject = objects[objects.length - 1];
      if (+value > +this.json.countcover[lastItemInObject]?.max) {
        this.sizeWidth = this.json.countcover[lastItemInObject]?.max;
        this.parentFormData.inputWidth = this.sizeWidth;
        this.changeCountCover(
          this.json.countcover[lastItemInObject],
          lastItemInObject
        );
      }
    },
    sizeHeight(value) {
      if (value > this.jsonData?.size?.height?.max) {
        this.sizeHeight = this.jsonData?.size?.height?.max;
        this.parentFormData.inputHeight = this.sizeHeight;
      }
    },
    kreplenie_for_alumini(val){
      this.parentFormData.kreplenie_for_alumini = val;
      this.$emit("loadData", this.parentFormData);
    }
  },
  async mounted() {
    await this.defaultSelect();
  },
  methods: {
    // Скрывает фильтр,если отсутствует ручка
    classHiddenHandle(index) {
      if (index == "handle") {
        if (this.parentFormData && this.parentFormData?.handle) {
          return !this.parentFormData?.handle?.handleName ? "hidden" : "";
        } else {
          return;
        }
      }
    },
    // Возращает массив без категории
    selectedNotCategory(value) {
      if (value?.category) {
        const { category, ...items } = value;
        return items;
      } else {
        return value;
      }
    },
    // Показывает в мобильном разрешении в модальном окне картинку
    showModalMobilePreview(index) {
      if (this.mobile) {
        let boolKey = Object.keys(this.opened).find(
          (key) => this.opened[key] === true
        );
        return boolKey === index;
      }
    },
    // В мобильном разрешении в модальном окне показывает выбранный фильтр
    showModalMobile(index) {
      if (this.mobile) {
        let boolKey = Object.keys(this.opened).find(
          (key) => this.opened[key] === true
        );
        return boolKey === index;
      } else {
        return true;
      }
    },
    // readDescription(item, index) {
    //   if (item?.handleName) {
    //     return item?.handleName;
    //   }
    // },

    // Показывает результат названия выбранной ручки
    readResultHandle(index) {
      if (index == "handle") {
        return this.parentFormData?.handle?.handleName;
      }
    },
    // Показывает результаты выбранных фильтров
    readResult(index) {
      switch (index) {
        case "glass":
          return this.parentFormData?.glass?.color;
        case "cover":
          return this.parentFormData?.cover?.color;
        case "countcover":
          return this.readDescriptionCover(this.selectedCountCover?.countcover);
        case "mechanism":
          return this.selectedMechanism.index;
        case "handle":
          return this.parentFormData?.handle?.handleColor;
      }
    },
    changeCoverGlass(itemData, index, indexParent, category) {
      if (category && ["glass", "cover"].includes(indexParent)) {
        itemData.category = category;
      }
      if (indexParent === 'cover') {

        const $articulText = $('.js--articul');
        const ID = $articulText.attr('data-id'),
            polotnoID = itemData.id;
        $.ajax({
          method: "GET",
          url: '/ajax/getArticul.php',
          data: {'id': ID, 'partitions_color_id': polotnoID},
        }).always(function (articul) {
          $articulText.text(articul);
        });

      }
      this.$set(this.parentFormData, indexParent, itemData);
      this.$emit("loadData", this.parentFormData);
    },
    // Дефолтный выбор первых элементов
    defaultSelect() {
      Object.keys(this.jsonData).forEach((key) => {
        switch (key) {
          case "countcover":
            for (const [keys, value] of Object.entries(this.jsonData[key])) {
              const { min, max } = value;
              if (this.sizeWidth >= min && this.sizeWidth <= max) {
                this.selectedCountCover = { ...value, countcover: keys };
                this.parentFormData.countcover = this.selectedCountCover;
                break;
              }
            }
            break;
          case "mechanism":
            let id = this.selectedCountCover.countcover;
            let [index, obj] = Object.entries(this.jsonData[key][id])[0];
            this.changeMechanism(obj, index);
            break;
          case "glass":
          case "cover":
            if (this.jsonData[key].length > 0) {
              const nameKey = `selected${key.replace(/^\w/, (c) =>
                c.toUpperCase()
              )}`;
              this[nameKey] = this.jsonData[key][0].items[0];
              this.changeCoverGlass(
                this[nameKey],
                null,
                key,
                this.jsonData[key][0].category
              );
            }
            break;
          case "handle":
            this.$nextTick(() => {
              this.defaultSelectHandle();
            });
            break;
          case "kreplenie_for_alumini":

            this.kreplenie_for_alumini = Object.keys(this.jsonData.kreplenie_for_alumini)[0];
            
            break;
          case "glass":
          default:
            break;
        }
      });
      this.parentFormData.inputWidth = this.sizeWidth;
      this.parentFormData.inputHeight = this.sizeHeight;
    },
    defaultSelectHandle() {
      const nameKey = `selected${"handle".replace(/^\w/, (c) =>
        c.toUpperCase()
      )}`;
      const handleData = this.jsonData["handle"];
      if (handleData && handleData.length > 0) {
        const arr = Object.assign(
          {},
          handleData[this.activeTabIndexGroup.handle]
        );
        arr.items = arr?.items.filter((el) => {
          return (
            el.mechanicsName &&
            this.parentFormData &&
            this.parentFormData.mechanism &&
            this.parentFormData.mechanism.index &&
            this.parentFormData.mechanism.index.indexOf(el.mechanicsName) !== -1
          );
        });
        if (arr.items && arr.items.length > 0) {
          this[nameKey] = arr.items[0];
          this.changeCoverGlass(this[nameKey], null, "handle", arr.collection);
        }
      }
    },
    changeCountCover(item, count) {
      this.selectedCountCover = { ...item, countcover: count };
      this.parentFormData.countcover = this.selectedCountCover;
      // this.$set(this.parentFormData,'countcover',{ ...item, countcover: count })
      this.$emit("loadData", this.parentFormData);
    },
    // Метод отслеживания минимальной и максимальной ширины
    readInputWidthValue() {
      let obj = this.jsonData.countcover;
      for (const key in obj) {
        const element = obj[key];
        if (this.sizeWidth >= element?.min && this.sizeWidth <= element.max) {
          this.sizeWidth = Math.ceil(this.sizeWidth / 10) * 10;
          this.parentFormData.inputWidth = this.sizeWidth;
          this.changeCountCover(element, key);
          break;
        }
        if (this.sizeWidth < element?.min && this.sizeWidth < element.max) {
          this.sizeWidth = element?.min;
          this.parentFormData.inputWidth = +this.sizeWidth;
          this.changeCountCover(element, key);
          break;
        }
      }
      this.$emit("loadData", this.parentFormData);
    },
    // Метод отслеживания минимальной и максимальной высоты
    readInputHeightValue() {
      if (
        this.sizeHeight >= this.jsonData?.size?.height?.min &&
        this.sizeHeight <= this.jsonData?.size?.height?.max
      ) {
        this.sizeHeight = Math.ceil(this.sizeHeight / 50) * 50;
        this.parentFormData.inputHeight = this.sizeHeight;
      } else if (this.sizeHeight < this.jsonData?.size?.height?.min) {
        this.sizeHeight = this.jsonData?.size?.height?.min;
        this.parentFormData.inputHeight = this.sizeHeight;
      }
      this.$emit("loadData", this.parentFormData);
    },
    changeMechanism(mechanism, indexMechanism) {
      const { price } = mechanism;
      this.selectedMechanism = { price, index: indexMechanism };
      this.parentFormData.mechanism = this.selectedMechanism;
      this.$emit("loadData", this.parentFormData);
    },
    // Описание выбранного полотна
    readDescriptionCover(countCover) {
      let result = "";
      let n = Math.abs(countCover);
      n %= 100;
      if (n >= 5 && n <= 20) {
        result = "полотен";
      }
      n %= 10;
      if (n === 1) {
        result = "полотно";
      }
      if (n >= 2 && n <= 4) {
        result = "полотна";
      }
      return `${countCover} ${result}`;
    },
    // Переключение табов и выбор первых параметров
    clickTab(index, item, indexNav) {
      if (index == "cover" || index == "glass") {
        if (item.items) {
          this.changeCoverGlass(
            { ...item.items[0] },
            null,
            index,
            item.category
          );
        }
      } else if (index == "handle") {
        const nameKey = `selected${"handle".replace(/^\w/, (c) =>
          c.toUpperCase()
        )}`;
        const handleData = this.jsonData["handle"];
        const idx = +this.activeTabIndexGroup.handle;
        if (handleData && handleData.length > 0) {
          const arr = Object.assign({}, handleData[idx]);
          arr.items = arr?.items.filter((el) => {
            return (
              el.mechanicsName &&
              this.parentFormData &&
              this.parentFormData.mechanism &&
              this.parentFormData.mechanism.index &&
              this.parentFormData.mechanism.index.indexOf(el.mechanicsName) !==
                -1
            );
          });
          if (arr.items && arr.items.length > 0) {
            this[nameKey] = arr.items[0];
            this.changeCoverGlass(
              this[nameKey],
              null,
              "handle",
              arr.collection
            );
          }
        }
      } else {
        this.parentFormData[index] = item;
      }
      this.activeTabIndexGroup[index] = indexNav;
      this.$emit("loadData", this.parentFormData);
    },
    // Заголовок фильтра
    readTitleGroup(index) {
      switch (index) {
        case "glass":
          return "Стекло";
        case "cover":
          return "Отделка";
        case "size":
          return "Размеры проёма";
        case "countcover":
          return "Количество полотен";
        case "mechanism":
          return "Механизм";
        case "handle":
          if (this.parentFormData && this.parentFormData?.handle) {
            return this.parentFormData?.handle?.handleName ? "Ручка" : "";
          } else {
            return "";
          }
        case "fittings":
          return "Фурнитура";
        case "kreplenie_for_alumini":
          return "Крепление";
        default:
          return "";
      }
    },
  },
  emits: ["loadData"],
  props: {
    jsonData: Object,
    json: [Object, String],
    mobile: Boolean,
    opened: Object,
    selected: Object,
  },
  components: {
    TheTabsItem,
    TheTabMenu,
    TheTabImage
  },
};
</script>

<style>
.door-config__group-wrapper {
  padding-bottom: 12px;
  display: grid;
  gap: 30px;
}

.tabs.flex {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 30px;
}

.glass {
  grid-row: 1;
}

.cover {
  grid-row: 2;
}

#modal_handle {
  grid-row: 6;
}

.size {
  grid-row: 3;
}

.countcover {
  display: flex;
  gap: 8px;
}

.countcover.hidden {
  display: none;
}

.handle.hidden {
  display: none;
}

.countcover .door-config__cover input[type="radio"] + i {
  width: 120px;
  height: 152px;
}

.mechanism {
}

.mechanism .door-config__cover input[type="radio"] + i {
  width: 175px;
  height: 130px;
}

.door-config__coverings-handle {
  display: none;
}

.door-config__tab-menu__link {
  cursor: pointer;
}

.door-config__coverings-handle._active {
  display: flex;
}

.js--inputs {
  display: flex;
  gap: 8px;
  align-items: center;
}

.js--inputs .form-item {
  max-width: 125px;
}

#modal_prices {
  display: none;
}

#modal_glass .popup__close,
#modal_cover .popup__close,
#modal_mechanism .popup__close,
#modal_countcover .popup__close,
#modal_handle .popup__close,
#modal_size .popup__close {
  display: none;
}

.h3.color-green.info__size {
  display: flex;
}

.door-config__cover.info__size > span {
  width: 240px;
  font-weight: 400;
  text-transform: none;
  text-align: center;
  font-size: 12px;
  color: #151616;
}

.door-config__cover.info__size:hover > span {
  display: block;
}

.door-config__info.info__size {
  display: block;
  width: auto;
  top: -2px;
  left: 5px;
}

@media (max-width: 768px) {
  .door-config__group-wrapper {
    display: contents;
  }

  .door-config__cover.info__size {
    display: none;
  }
}
</style>
